<div class="right-panel" [class.right-panel_open]="isOpen">
  <ng-content></ng-content>
</div>

<div class="background" *ngIf="isOpen" (click)="onClose()"></div>
